//* Libraries imports
import { useMutation } from "@tanstack/react-query";
import z from "zod";

//* Axios Import
import { privateApi } from "../../../services/apis/configs/apiClient";

//* Schemas imports
import { responseDeletedSchema } from "../../../schemas/api-response";

async function destroyResourceQuestion(questionId: string) {

    try {
        const url = `/student_portal/private/recursos/questoes/${questionId}`;
        const response = await privateApi.delete(url);
        return responseDeletedSchema.parse(response);
    }
    catch (error) {
        if (error instanceof z.ZodError) {
            throw new Error(`Validation error: ${error.message}`);
        } else if (error instanceof Error) {
            throw new Error(`API error: ${error.message}`);
        } else {
            throw new Error("An unexpected error occurred");
        }
    }
}


export function useDestroyResourceQuestion() {
    return useMutation({
        mutationFn: destroyResourceQuestion,
        onError: (error) => {
            console.error("Error deleting resource question:", error);
        },
    });
}